import React from "react";
import logo from "../../images/iteratecLogo.png";
import {AppBar, Toolbar} from "@mui/material";
import { withStyles } from 'tss-react/mui';
import LocalLanguageSelection from "../language-selection/LocalLanguageSelection";

const styles = theme => ({
    appBar: {
        [theme.breakpoints.up("sm")]: {
            width: "100%",
        },
    },
    logo: {
        height: "64px"
    },
    toolBar: {
        justifyContent: "space-between"
    },
    headerButton: {
        paddingLeft: "20px",
        paddingRight: "20px"
    }
});

class Header extends React.Component {

    render() {
        const {classes} = this.props;

        return (
            <AppBar className={classes.appBar} position="fixed">
                <Toolbar className={classes.toolBar}>
                    <img alt="Tiger" src={logo} className={classes.logo}/>
                    <LocalLanguageSelection/>
                </Toolbar>
            </AppBar>
        );
    }
}

export default withStyles(Header, styles);